// Constants
import { TableName } from "@ms/uno-constants/lib/local/StoreConstants";
// Models
import { QueryRelationship } from "@ms/planner-models/lib/local/client/planner/EntityRelationships";
// Stores
import { Store } from "./Store";
// Utilities
import { collection, status } from "@ms/uno-utilities/lib/local/storage/TableNameUtilities";
/**
 * Configuration object that defines which specific tables should be persisted for each store.
 * This allows granular control over persistence per store type.
 */ export const PERSISTED_STORES_TABLES_CONFIG = {
    [Store.Mru]: [
        TableName.Mru
    ],
    [Store.Tasks]: [
        TableName.Tasks,
        collection(TableName.Tasks, QueryRelationship.TasksInPlan),
        collection(TableName.Tasks, QueryRelationship.TasksAssignedToUser),
        collection(TableName.Tasks, QueryRelationship.TasksInMyDayOfUser)
    ],
    [Store.Plan]: [
        TableName.Plan,
        status(TableName.Plan)
    ],
    [Store.Bucket]: [
        TableName.Bucket,
        collection(TableName.Bucket, QueryRelationship.BucketsInPlan)
    ],
    [Store.View]: [
        TableName.ViewConfig
    ],
    [Store.CustomFieldDefinition]: [
        TableName.CustomFieldDefinitions,
        collection(TableName.CustomFieldDefinitions, QueryRelationship.CustomFieldDefinitionsInPlan)
    ],
    [Store.PinnedTasks]: [
        TableName.PinnedTasks
    ],
    [Store.TaskOrder]: [
        TableName.TaskOrder
    ]
};
/**
 * Status table names that all use the same serialization logic
 */ export const STATUS_TABLES = [
    status(TableName.Plan),
    collection(TableName.Bucket, QueryRelationship.BucketsInPlan),
    collection(TableName.Tasks, QueryRelationship.TasksInPlan),
    collection(TableName.Tasks, QueryRelationship.TasksInMyDayOfUser),
    collection(TableName.Tasks, QueryRelationship.TasksAssignedToUser),
    collection(TableName.CustomFieldDefinitions, QueryRelationship.CustomFieldDefinitionsInPlan)
];
